import { useEffect, useState } from "react";
// image and styles
import { logo } from "../img";
import styled from "styled-components";
import { colors } from "../styles/variables";

const BackToTopButton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    const updateVisibility = () => {
      setIsVisible(window.innerWidth > 768 && window.pageYOffset > 300);
    };

    updateVisibility();
    window.addEventListener("scroll", updateVisibility, { passive: true });
    window.addEventListener("resize", updateVisibility);

    return () => {
      window.removeEventListener("scroll", updateVisibility);
      window.removeEventListener("resize", updateVisibility);
    };
  }, []);

  const scrollToTop = () => {
    window.scroll({ top: 0, left: 0, behavior: "smooth" });
  };

  return (
    <>
      <LogoScrollButton
        onClick={scrollToTop}
        style={{ transform: `translateX(${isVisible ? 0 : -100}vw)` }}
      >
        <img src={logo} alt="Logo" />
      </LogoScrollButton>
      <CornerScrollButton
        type="button"
        $visible={isVisible}
        onClick={scrollToTop}
        aria-label="Scroll to top"
      >
        <svg viewBox="0 0 24 24" aria-hidden="true">
          <path d="M12 19V5" />
          <path d="m5 12 7-7 7 7" />
        </svg>
      </CornerScrollButton>
    </>
  );
};

// Original top-left logo tab styling.
const LogoScrollButton = styled.div`
  cursor: pointer;
  transition: 1s;
  width: 10vw;
  height: 8vh;
  background: ${colors.dark};
  padding: 0 0.5rem;
  border-radius: 0 0 0.5rem 0.5rem;
  position: fixed;
  top: 0;
  left: 2vw;
  z-index: 5;

  img {
    height: 100%;
    width: 100%;
    object-fit: contain;
  }

  @media (max-width: 1366px) {
    left: 0.8vw;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

const CornerScrollButton = styled.button<{ $visible: boolean }>`
  position: fixed;
  right: 1.5rem;
  bottom: 1.5rem;
  z-index: 5;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 3.5rem;
  height: 3.5rem;
  padding: 0;
  cursor: pointer;
  background: ${colors.dark};
  border: 2px solid ${colors.primary};
  border-radius: 50%;
  box-shadow: 0 4px 14px rgba(0, 0, 0, 0.22);
  opacity: ${(props) => (props.$visible ? 1 : 0)};
  pointer-events: ${(props) => (props.$visible ? "auto" : "none")};
  transform: translateY(
    ${(props) => (props.$visible ? "0" : "calc(100% + 2rem)")}
  );
  transition:
    transform 0.6s ease,
    opacity 0.3s ease,
    box-shadow 0.2s ease;

  svg {
    width: 1.5rem;
    height: 1.5rem;
    fill: none;
    stroke: ${colors.white};
    stroke-width: 2;
    stroke-linecap: round;
    stroke-linejoin: round;
    transition: transform 0.2s ease;
  }

  &:hover {
    background: ${colors.primary};
    border-color: ${colors.primary};
    box-shadow: 0 4px 16px rgba(0, 0, 0, 0.25);

    svg {
      transform: translateY(-0.2rem);
    }
  }

  &:focus-visible {
    outline: 3px solid ${colors.primary};
    outline-offset: 3px;
  }

  @media (max-width: 768px) {
    display: none;
  }
`;

export default BackToTopButton;
